import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
})
export class FooterComponent {
    private _isSupplierTicketingEnabled = false;
    @Input() set isSupplierTicketingEnabled(val) {
        this._isSupplierTicketingEnabled = val;
    }
    get isSupplierTicketingEnabled() {
        return this._isSupplierTicketingEnabled;
    }

    get legalUrl(): string {
        return 'https://www.tesla.com/about/legal';
    }
}
